<template lang="pug">
  main
    NavBarCORP
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns.section-title
          .column.is-half.is-offset-one-quarter.has-text-centered.has-text-dark
            h1.title Documentos&nbsp
              a.button.is-black.is-rounded.mr-3(@click="backPage" title="Regresar")
                i.fas.fa-times
        nav.breadcrumb.is-centered(aria-label="breadcrumbs")
            ul
              li
                a(href="/Apartado/SASISOPA") Terminales
              li
                a Documentos
        .columns.has-text-centered.is-centered.is-multiline.has-text-dark
          .column.is-3(v-for="(document, index) in documents" :key="index")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-file-signature.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 {{ document.consecutive }}. {{ document.code }} - {{ document.name }}
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(:to="`/SASISOPA/ambitos/${document.terminal_id}/${document.id}`") Entrar
                router-link.a.button.is-black.is-rounded.is-size-6.ml-2(:to="`/SASISOPA/documentos/${document.terminal_id}/${document.id}/editar`" v-if="permisos.permisos_sasisopa_id == 1")
                  i.fas.fa-pen
                a.button.is-danger.is-rounded.ml-2(@click="deleteItem(document.id)" title="Eliminar" v-if="permisos.permisos_sasisopa_id == 1")
                    i.fas.fa-trash

          .column.is-3(v-if="this.permisos.permisos_sasisopa_id == 1")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-plus.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Agregar documento
                br
                //- a.button.is-black.is-rounded(@click="fetchData")
                router-link.a.button.is-black.is-rounded.is-size-6(:to="`/SASISOPA/archivos/${idRoute}/agregar`" title="Agregar apartado") Agregar
                //- router-link.a.button.is-dark.is-rounded.is-size-6(:to="`/SASISOPA/ambitos/${idRoute}/agregar`") Agregar

        .modal.is-active(v-if="isModalActive")
              .modal-background.custom-background
              .modal-card
                header.modal-card-head
                  p.modal-card-title ¿Estás seguro de que deseas eliminar esta Document?
                  button.modal-close.is-large(@click="closeModal")
                  button.button(@click="closeModal")
                    i.fas.fa-times
                section.modal-card-body.has-text-centered.strong
                  i.is-alert.is-large.fa.fa-exclamation.mb-2
                  br
                  br
                  strong Esta acción es irreversible y el CONTENIDO que se encuentra DENTRO DE LA CARPETA TAMBIEN SERÁ ELIMINADO.
                footer.modal-card-foot.has-text-right
                  .buttons
                    button.button.is-dark(@click="confirmDelete") Eliminar de todos modos
                    button.button.is-black(@click="closeModal") Cancelar
</template>

<script>
import Loader from '@/components/shared/Loader.vue'
import NavBarCORP from '@/components/layout/NavBarCorpo.vue'
import { mapState } from 'vuex'
import sasisopaAPI from "@/services/axios_sasisopa.js";

export default {
  name: 'DocumentsSASISOPA',
  components: { Loader, NavBarCORP },
  data () {
    const id = this.$route.params.id;
    return {
      isLoading: false,
      documents: [],
      idRoute: id,
      isModalActive: false,
      DocumentToDelete: null,
    }
  },
  methods: {
    async fetchData() {
      try {
        this.isLoading = true;
        const response = await sasisopaAPI.getDocuments(this.$route.params.id);
        this.documents = response.data;
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        this.isLoading = false;
      }
    },
    deleteItem(id) {
      this.DocumentToDelete = id;
      this.isModalActive = true;
    },
    async confirmDelete() {
      if (this.DocumentToDelete) {
        try {
          this.isLoading = true;
          await sasisopaAPI.DeleteDocument(this.DocumentToDelete);
          this.Documents = this.Documents.filter(Document => Document.id !== this.DocumentToDelete);
        } catch (error) {
          this.fetchData();
        } finally {
          this.isLoading = false;
          this.isModalActive = false;
          this.DocumentToDelete = null;
        }
      }
    },
    closeModal(){
      this.isModalActive = false;
    },
    backPage() {
      this.$router.back()
    },
    obtenerUser() {
    },
    async leerEstructuraDeCarpeta() {
      // Verificar si la API está soportada
      if (!window.showDirectoryPicker) {
        console.error('La API de File System Access no es soportada en este navegador.');
        return;
      }

      try {
        const carpeta = await window.showDirectoryPicker();
        console.log(carpeta);
        await this.leerCarpeta(carpeta);
      } catch (error) {
        console.error("Error al leer la carpeta:", error);
      }
    },
    async leerCarpeta(carpeta) {
      const directorios = [];
      for await (const entrada of carpeta.values()) {
        if (entrada.kind === 'directory') {
          directorios.push(entrada.name);
        }
      }
      console.log(directorios);
    },

  },
  created () {
    this.$store.commit('irEstaciones','CORP')
    this.obtenerUser()
    this.fetchData();
  },
  computed: {
    ...mapState(['logueado', 'userLogin', 'permisos'])
  },
}
</script>

<style lang="css" scoped>

  .image {
    display: inline-block;
  }
  .card:hover {
    transform: translateY(-5px) scale(1.005) translateZ(0);
    box-shadow: 0 24px 36px rgba(0,0,0,0.11), 0 14px 16px rgba(0,0,0,0.11);
  }
  .section-title {
    margin-top: 1rem;
    margin-bottom: 2rem;
  }

  .card {
    color: #54545c;
  }
    .custom-background {
  background-color: #0c0c0cc0;
}
.is-alert {
  color: rgb(245, 68, 68);
}

.modal-card-body {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.fa-exclamation {
  font-size: 3rem;
}
</style>




// WEBPACK FOOTER //
// src/components/sasisopa/DocumentsSASISOPA.vue